import { lazy } from 'react';

const ChartMapsRoutes = [
  {
    path: '/contact-support',
    component: lazy(() => import('../../views/pages/ContactSupport')),
  },
];

export default ChartMapsRoutes;
